module.exports = __webpack_public_path__ + "static/media/china.82c842c2.svg";